"use client";

import { createContext, useContext, useState, type Dispatch, type SetStateAction, type ReactNode } from "react";
import { DEFAULT_LOCALE, type SiteLocale } from "@/lib/i18n/config";
import { localizeInternalHref } from "@/lib/i18n/paths";
import type { BlogLocaleNavigation } from "@/lib/blog/locale-navigation";

const CcLocaleContext = createContext<SiteLocale>(DEFAULT_LOCALE);
const CcBlogLocaleContext = createContext<{
  navigation: BlogLocaleNavigation | null;
  setNavigation: Dispatch<SetStateAction<BlogLocaleNavigation | null>>;
}>({ navigation: null, setNavigation: () => {} });

type CcLocaleProviderProps = {
  locale: SiteLocale;
  children: ReactNode;
  blogNavigation?: BlogLocaleNavigation | null;
};

export function CcLocaleProvider({ locale, children, blogNavigation = null }: CcLocaleProviderProps) {
  const [navigation, setNavigation] = useState(blogNavigation);
  return <CcLocaleContext.Provider value={locale}><CcBlogLocaleContext.Provider value={{ navigation, setNavigation }}>{children}</CcBlogLocaleContext.Provider></CcLocaleContext.Provider>;
}

export function useBlogLocaleNavigation() {
  return useContext(CcBlogLocaleContext);
}

export function useSiteLocale(): SiteLocale {
  return useContext(CcLocaleContext);
}

export function useLocalizedHref(href: string): string {
  const locale = useSiteLocale();
  return localizeInternalHref(href, locale);
}
